import actionCreatorFactory from 'typescript-fsa'

import {
  CreateUserFromWizardRequest,
  ErrorResponse,
  NewUserForm,
  NewUserFormSteps,
  NewUserPossibleFormStepValues,
  User,
} from '~api/models'

const actionCreator = actionCreatorFactory('RCP_WIZARD')

export type NewUserFormAvailableSteps = NewUserFormSteps | 'success'

export interface UpdateFormStepValuesProps {
  step: NewUserFormSteps
  values: NewUserPossibleFormStepValues
}

/**
 * Actions
 */
export const updateFormValues = actionCreator<NewUserForm>('UPDATE_FORM_VALUES')
export const updateFormStepValues = actionCreator<UpdateFormStepValuesProps>('UPDATE_FORM_STEP_VALUES')
export const updateFormStepValuesAndSubmit = actionCreator<UpdateFormStepValuesProps>('UPDATE_FORM_STEP_VALUES_AND_SUBMIT')
export const resetForm = actionCreator<void>('RESET_FORM')
export const setCurrentStep = actionCreator<NewUserFormAvailableSteps>('SET_CURRENT_STEP')

export const submitForm = actionCreator.async<CreateUserFromWizardRequest, User, ErrorResponse>('SUBMIT_FORM')
